module.exports = __webpack_public_path__ + "img/win_icon.8ae1057a.svg";